import { render } from "./GiftCards.vue?vue&type=template&id=58fe0a0a"
import script from "./GiftCards.vue?vue&type=script&lang=js"
export * from "./GiftCards.vue?vue&type=script&lang=js"
script.render = render

export default script